import axios from 'axios'
import i18n from '@/locales/i18n'

// Add request interceptor to include locale in headers
axios.interceptors.request.use(
  (config) => {
    // Get current locale from i18n
    const currentLocale = i18n.global.locale.value || 'de'
    
    // Add locale to headers
    config.headers['X-Locale'] = currentLocale
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default axios
